<template>
  <div class="ui mini modal" ref="modal">
    <!--Mismo caso-->
    <i class="close icon" @click="$emit('close')"></i>
    <div class="content">
      <div class="ui form" ref="form">
        <h3 class="ui dividing header fdinpro default-header-green">
          {{ $t("code send") }}
        </h3>
        <div class="field ui disabled">
          <label class="pt-05 fdinpro label-form">{{ $t("bundle") }}</label>
          <input
            type="text"
            name="bundle"
            placeholder=""
            v-model="bundle.setup.name"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form"
            >{{ $t("codes quantity") }} [{{ available }}
            {{ $t("available") }}]</label
          >
          <input
            type="text"
            name="cantidad_codigos"
            placeholder=""
            v-model="code_quantity"
          />
        </div>
        <div
          class="ui fluid button modal-button-green"
          tabindex="0"
          @click="request"
        >
          {{ $t("send") }}
        </div>
        <div class="ui error message"></div>
      </div>
      <h3 class="ui dividing header fdinpro default-header-green is-uppercase">
        {{ $t("code send list") }}
      </h3>
      <div class="table-codes- px-gen m-0 pb-05">
        <table class="ui very compact basic striped table px-gen" ref="table">
          <thead>
            <tr>
              <th class="is-uppercase">{{ $t("fecha") }}</th>
              <th class="is-uppercase">{{ $t("cantidad") }}</th>
              <th class="is-uppercase">{{ $t("accion") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(send, index) in sends" :key="index">
              <td>
                {{
                  send.create_date
                    | formatDate(enterprise_setup.simple_date_format)
                }}
              </td>
              <td>{{ send.quantity }}</td>
              <td>
                <a
                  @click="download(send)"
                  v-show="
                    !send.downloading_data || !send.downloading_data.length
                  "
                  >{{ $t("load data") }}</a
                >
                <download-excel
                  :data="send.downloading_data"
                  v-show="send.downloading_data && send.downloading_data.length"
                >
                  {{ $t("download") }}
                  <img
                    class="ui mini image"
                    src="images/icons/download_excel.png"
                  />
                </download-excel>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  enterprise_setup,
  success_toast,
} from "@/utils";
import filters from "@/filters";
import JsonExcel from "vue-json-excel";
// import vueFilePond from "vue-filepond";
// import uuid from "uuid/v4";
// Import FilePond styles
// import "filepond/dist/filepond.min.css";

// const FilePond = vueFilePond();
// console.log(typeof SimpleExcel, SimpleExcel);

export default {
  components: {
    downloadExcel: JsonExcel,
    // FilePond,
  },
  name: "",
  props: {},
  filters: filters,
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      bundle: { setup: { name: "" } },
      code_quantity: 0,
      data: {},
      sends: [],
      downloading_data: [],
      available: "",
    };
  },
  methods: {
    request() {
      let vm = this;
      if (vm.code_quantity && Number(vm.code_quantity > 0)) {
        local_api(vm, "post", "/nworkforce_nvidia/do-send-codes", {
          b: vm.bundle.bundle_id,
          s: vm.data.store_id,
          q: vm.code_quantity,
        })
          .then(function() {
            success_toast(vm.$t("codes sent"));
            vm.hide();
          })
          .catch(function(err) {
            error_toast(err);
          });
      } else {
        error_toast(vm.$t("enter how many codes you will send"));
      }
    },
    hide() {
      let vm = this;
      window.jQuery(vm.$refs.modal).modal("hide");
    },
    show(storeData, bundle) {
      let vm = this;
      vm.bundle = bundle;
      vm.data = storeData;

      vm.get_store_sends();

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHidden() {
            vm.bundle = { setup: { name: "" } };
            vm.code_quantity = 0;
          },
        })
        .modal("show");
    },
    get_store_sends() {
      let vm = this;
      local_api(vm, "post", "/nworkforce_nvidia/do-get-store-sends", {
        b: vm.bundle.bundle_id,
        s: vm.data.store_id,
      })
        .then(function(r) {
          vm.sends = r.sends.map((s) => {
            s.downloading_data = [];
            return s;
          });
          vm.available = r.available;
        })
        .catch(function(err) {
          error_toast(err);
        });
    },
    download(send) {
      let vm = this;
      local_api(vm, "post", "/nworkforce_nvidia/do-download-send-codes", {
        s: send.send_id,
      })
        .then(function(r) {
          send.downloading_data = r;
        })
        .catch(function(err) {
          error_toast(err);
        });
    },
  },
};
</script>

<style scoped>
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}

/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
